import { deconstructNode } from '~/libs/contentful/helpers'
import { TypeDescriptiveSlider } from '~/types/contentful/TypeDescriptiveSlider'
import { SliderItem } from './types'
import { SliderItem as SliderItemComponent } from './SliderItem'
import { useSlider } from './useSlider'

type DescriptiveSliderProps = {
  descriptiveSlider: TypeDescriptiveSlider<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const DescriptiveSlider = ({ descriptiveSlider }: DescriptiveSliderProps) => {
  const { fields } = deconstructNode(descriptiveSlider) as TypeDescriptiveSlider<
    'WITHOUT_UNRESOLVABLE_LINKS',
    string
  >
  const { title, description, descriptiveSliderItems } = fields

  const descriptiveSliderItemsArray: SliderItem[] =
    descriptiveSliderItems?.content
      ?.filter((item) => item.nodeType === 'embedded-entry-block')
      .map((item) => {
        const { fields } = deconstructNode(item)
        return {
          title: (fields?.title as string) || '',
          description: (fields?.description as string) || '',
        }
      }) || []

  if (!descriptiveSliderItemsArray.length) {
    return null
  }

  const { activeItem, currentIndex, handleItemClick } = useSlider(descriptiveSliderItemsArray)

  return (
    <div className="flex flex-col items-start self-stretch mt-12 p-2 pt-0 rounded-2xl bg-neutral-5">
      <div className="flex flex-col justify-center items-center gap-3 self-stretch py-6 px-4">
        <span className="text-m text-neutral-100 self-stretch">{title}</span>
        <span className="text-xs text-neutral-60 self-stretch">{description}</span>
      </div>
      <div className="flex items-start gap-2 self-stretch">
        <div className="flex flex-col items-start gap-0.5 w-full md:max-w-64">
          {descriptiveSliderItemsArray.map((item, index) => (
            <SliderItemComponent
              key={index}
              item={item}
              activeItem={activeItem}
              isActive={index === currentIndex}
              onClick={() => handleItemClick(item, index)}
            />
          ))}
        </div>
        <div className="hidden md:flex flex-col flex-1 items-start gap-2 p-6 self-stretch rounded-2xl bg-white animate-fade-in">
          <span className="text-s text-neutral-100 self-stretch">{activeItem.title || ''}</span>
          <span className="text-xs text-neutral-60 self-stretch">
            {activeItem.description || ''}
          </span>
        </div>
      </div>
    </div>
  )
}
